import './sass/main.scss'
import React, { useRef, useState } from 'react'
import Logo from './assets/logo.png'
import Video from './assets/video.mp4'
import VideoWebm from './assets/video.webm'
import Titulo from './assets/titulo.png'
import { motion } from 'framer-motion'
import Hamburger from 'hamburger-react'
import { isMobile } from "react-device-detect"

import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, A11y, Autoplay } from 'swiper'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import SlideImg1 from 'assets/slider-1.png'
import SlideImg2 from 'assets/slider-2.png'
import SlideImg3 from 'assets/slider-3.png'

import WhatsIcon from 'assets/whats_icon.png'
import EmailIcon from 'assets/email_icon.png'
import PhoneIcon from 'assets/phone_icon.png'
import LocationIcon from 'assets/location.png'

import Youtube from 'assets/youtube.png'
import Facebook from 'assets/facebook.png'
import Instagram from 'assets/instagram.png'
import Telegram from 'assets/telegram.png'
import Twitter from 'assets/twitter.png'

import LogoCerimonialDourado from 'assets/cerimonial_logo_dourado.png'
import LogoTEMS from 'assets/logo_tems.png'
import SantuarioLogo from 'assets/logo_santuario.png'
import ClaLogo from 'assets/logo_cla.png'
import GraficaAguiaLogo from 'assets/grafica_logo.png'
import { useFetchProductsQuery } from 'store'
import SwiperButtonNext from 'SwiperStoreButtonNext'
import SwiperButtonPrev from 'SwiperStoreButtonPrev'


export default function App() {

  const [isOpen, setOpen] = useState(false);
  const imgs = [SlideImg1, SlideImg2, SlideImg3];

  const { data } = useFetchProductsQuery();

  const programacaoRef = useRef();
  const produtosRef = useRef();
  const contatoRef = useRef();
  const hoteisRef = useRef();

  let productsContent;

  const buttonAttributes = !isMobile ? {
    initial: { opacity: 0, y: '100' },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 2.5 },
  } : '';

  const imgAttributes = !isMobile ? {
    initial: { opacity: 0, y: '-100' },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 2.5 },
  } : '';

  const pAttributes = !isMobile ? {
    initial: { opacity: 0, y: '-100' },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 2.5 }
  } : ''

  if (data) {
    productsContent =
      <div style={{ position: 'relative' }}>
        <Swiper
          modules={[Navigation, A11y, Autoplay]}
          spaceBetween={0}
          slidesPerView={2}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          navigation={{
            nextEl: '.produtos__arrow-right',
            prevEl: '.produtos__arrow-left',
          }}
          loop={true}
          pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
          breakpoints={{
            300: {
              width: 300,
              slidesPerView: 1
            },
            768: {
              slidesPerView: 2
            }
          }}
        >

          {data.map(product => {
            return (
              <SwiperSlide key={product.id}>
                <a href={product.permalink} target='_blank'>
                  <div className='produtos__container'>
                    <img src={product.images[0].src} className='produtos__img' />
                  </div>
                </a>
              </SwiperSlide>
            );
          })}

        </Swiper>
        <SwiperButtonNext />
        <SwiperButtonPrev />
      </div>
  }

  return (
    <div className='container'>
      <header className='header'>

        <div className="header__bg-video">
          <video className="header__bg-video__content" autoPlay muted loop>
            <source src={Video} type="video/mp4" />
            <source src={VideoWebm} type="video/webm" />
            Your browser is not supported!
          </video>
        </div>

        <div className='navigation'>

          <img className='navigation__logo' src={Logo} alt='Logo TEMS | Templo Espiritual Maria Santíssima' />


          <nav className='navigation__nav'>
            <ul className={isMobile ? (isOpen ? 'show_side_bar navigation__list' : 'navigation__list') : 'navigation__list'}>
              <li className='navigation__item' onClick={() => programacaoRef.current.scrollIntoView({ behavior: "smooth" })}>Programação</li>
              <li className='navigation__item' onClick={() => hoteisRef.current.scrollIntoView({ behavior: "smooth" })}>Hotéis</li>
              <li className='navigation__item' onClick={() => produtosRef.current.scrollIntoView({ behavior: "smooth" })}>Produtos</li>
              <li className='navigation__item' onClick={() => contatoRef.current.scrollIntoView({ behavior: "smooth", block: 'center' })}>Contato</li>
            </ul>
          </nav>

          {isMobile ? <div style={{ marginRight: '20px' }}><Hamburger toggled={isOpen} toggle={setOpen} color="white" /></div> : ""}


        </div>

        <div className='header__titulo'>
          <motion.img
            className='header__titulo-img'
            src={Titulo} alt='Cerimonial Egípcio no Santuário Sara Kali'
            {...imgAttributes}
          />

          <motion.h4
            className='header__titulo-data'
            {...pAttributes}
          >
            <span>21</span> e <span>22</span> de Outubro
          </motion.h4>
          <motion.button
            className='header__titulo-button'
            {...buttonAttributes}
            onClick={() => window.location = 'https://santuariosarakali.com.br/produto/1o-encontro-internacional-das-caravanas-de-luz/'}
          >Adquirir ingresso</motion.button>
        </div>

      </header>

      <main>
        <section className='programacao'>
          <h3 className='programacao__title' ref={programacaoRef}>Programação</h3>
          <div className='programacao__container'>
            <div className='programacao__list-container'>
              <div className='programacao__list-box'>
                <h5 className='programacao__day'>
                  SÁBADO
                  <span>21 de outubro</span>
                </h5>
                <ul className='programacao__list'>
                  <li className='programacao__item'>
                    <div>
                      <span className='programacao__time'>8h</span> <span className='programacao__text'>Abertura do Santuário Sara Kali</span>

                    </div>
                  </li>

                  <li className='programacao__item'>
                    <div>
                      <span className='programacao__time'>8h30</span> <span className='programacao__text'>Abertura das Cantinas e Loja</span>

                    </div>
                  </li>

                  <li className='programacao__item'>
                    <div>
                      <span className='programacao__time'>9h</span> <span className='programacao__text'>Atendimento Espiritual</span>

                    </div>
                  </li>

                  <li className='programacao__item'>
                    <div>
                      <span className='programacao__time'>12h às 15h</span> <span className='programacao__text'>Abertura Refeitório para almoço</span>

                    </div>
                  </li>

                  <li className='programacao__item'>
                    <div>
                      <span className='programacao__time'>15h</span> <span className='programacao__text'>Término dos Atendimentos Espirituais</span>

                    </div>
                  </li>

                  <li className='programacao__item'>
                    <div>
                      <span className='programacao__time'>16h</span> <span className='programacao__text'>Preparação para a Cerimônia da Mandala</span>

                    </div>
                  </li>

                  <li className='programacao__item'>
                    <div>
                      <span className='programacao__time'>17h</span> <span className='programacao__text'>Cerimônia da Mandala</span>

                    </div>
                  </li>
                </ul>
              </div>

              <div className='programacao__list-box'>
                <h5 className='programacao__day'>
                  DOMINGO
                  <span>22 de outubro</span>
                </h5>
                <ul className='programacao__list'>
                  <li className='programacao__item'>
                    <div>
                      <span className='programacao__time'>8h</span> <span className='programacao__text'>Abertura Santuário Sara Kali</span>
                    </div>
                  </li>

                  <li className='programacao__item'>
                    <div>
                      <span className='programacao__time'>8h30</span> <span className='programacao__text'>Abertura das Cantinas e Loja</span>
                    </div>
                  </li>

                  <li className='programacao__item'>
                    <div>
                      <span className='programacao__time'>9h</span> <span className='programacao__text'>Hino Nacional / Hasteamento das Bandeiras / Palestra Gilberto Rissato</span>
                    </div>
                  </li>

                  <li className='programacao__item'>
                    <div>
                      <span className='programacao__time'>11h às 14h</span> <span className='programacao__text'>Abertura Refeitório para almoço</span>
                    </div>
                  </li>

                  <li className='programacao__item'>
                    <div>
                      <span className='programacao__time'>14h às 16h</span> <span className='programacao__text'>Livre / Confraternização</span>
                    </div>
                  </li>

                  <li className='programacao__item'>
                    <div>
                      <span className='programacao__time'>16h</span> <span className='programacao__text'>Encerramento com Cerimônia da Fogueira</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>


            <div className='programacao__slider'>
              <Swiper
                modules={[Navigation, Pagination, Autoplay, A11y]}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                loop={true}
              >
                {
                  imgs.map(img => {
                    return (
                      <SwiperSlide key={img}>
                        <div>
                          <img src={img} alt='Imagens do Ultimo Cerimonial Egípcio' />
                        </div>
                      </SwiperSlide>
                    );
                  })
                }
              </Swiper>
            </div>
          </div>
          <button className='programacao__button' onClick={() => window.location = 'https://santuariosarakali.com.br/produto/1o-encontro-internacional-das-caravanas-de-luz/'}>Garanta seu ingresso</button>
        </section>

        <section className='hoteis'>
          <h3 className='hoteis__title' ref={hoteisRef}>Hotéis Parceiros</h3>

          <table className='hoteis__table'>
            <tr>
              <th>Hotel</th>
              <th>Endereço</th>
              <th>Contato</th>
            </tr>
            <tr>
              <td>Arlen</td>
              <td>Praça Senador Eduardo Amaral, 96, Centro -
                Pouso Alegre/MG</td>
              <td>(35) 3422-9033<br />
                (35) 9 9937-6680</td>
            </tr>
            <tr>
              <td>Class</td>
              <td>Rod. BR 459, Km 104, 8, Ipiranga -
                Pouso Alegre/MG</td>
              <td>(35) 3425-4235<br />
                (35) 9 9833-0909</td>
            </tr>
            <tr>
              <td>Fênix</td>
              <td>Rua Bernadino de Campos, 143, Centro -
                Pouso Alegre/MG</td>
              <td>(35) 3449-2005<br />
                (35) 9 8861-1728</td>
            </tr>
            <tr>
              <td>Ferraz</td>
              <td> Praça Dr. Garcia Coutinho, 14, Centro -
                Pouso Alegre/MG</td>
              <td>(35) 3449-2045<br />
                (35) 9 852-9546</td>
            </tr>
            <tr>
              <td>Gran<br />Lago</td>
              <td>Av. Pref. Olavo Gomes de Oliveira, 3381, Árvore Grande -
                Pouso Alegre/MG</td>
              <td>(35) 3025-9100<br />
                (35) 9 9917-8371</td>
            </tr>
            <tr>
              <td>Pérez</td>
              <td>Rua Bom Jesus, 373, Centro - Pouso Alegre/MG</td>
              <td>(35) 3423-5779<br />
                (35) 3422-9033</td>
            </tr>
            <tr>
              <td>Marques Plaza</td>
              <td>Av. Pref. Tuany Toledo, 801, Fátima II - Pouso Alegre/MG</td>
              <td>(35) 3422-2020<br />
                (35) 9 9831-6196</td>
            </tr>
            <tr>
              <td>Zé Maria</td>
              <td>Av. Ver. Antônio da Costa Rios, 65, Centro -
                Pouso Alegre/MG</td>
              <td>(35) 3423-5322<br />
                (35) 9 8707-5845</td>
            </tr>
          </table>
          <p className='hoteis__warning-text'>Atenção: É muito importante para nós que se identifique como visitante
            do Santuário Sara Kali / Colônia Esperança</p>
        </section>

        <section className='produtos'>
          <div className='produtos__header-box'>
            <div className='produtos__text-box'>
              <h3 className='produtos__title' ref={produtosRef}>Produtos Exclusivos</h3>
              <p className='produtos__subtitle'>Leve a energia de Nossa Senhora e de todos os Irmãos Espirituais para sua casa. Adquira antecipadamente seus produtos exclusivos de mais esse evento no Santuário Sara Kali.</p>
            </div>
            <a className='produtos__button' href='https://temsonline.com.br/categoria-produto/destaque-site-tems/' target='_blank'>Adquirir produtos</a>
          </div>

          {productsContent}
        </section>

        <section className='contato'>
          <div className='contato__box'>
            <h3 className='contato__title' ref={contatoRef}>Contato</h3>
            <ul className='contato__list'>
              <li className='contato__item'><img src={LocationIcon} />Estrada Municipal Joaquim Rezende Filho, Bairro dos Ferreiras - Pouso Alegre/MG<br /><br />
                Entrada pela Rodovia Fernão Dias, km 865 (sentido Belo Horizonte/MG) ou pela Rodovia Fernão Dias, Km 864 (Sentido São Paulo/SP)</li>

              <li className='contato__item'><img src={PhoneIcon} />+55 (11) 3354-1500</li>
              <li className='contato__item'><img src={WhatsIcon} />+55 (35) 9 9929-2435 | +55 (11) 9 9811-7698</li>
              <li className='contato__item'><img src={EmailIcon} />faleconosco@tems.com.br</li>
            </ul>
          </div>
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14758.781883707856!2d-45.8849377!3d-22.3651247!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cb953e06f36cdf%3A0x6d7b2b986f9c2903!2sSantu%C3%A1rio%20Sara%20Kali!5e0!3m2!1spt-BR!2sbr!4v1690308240568!5m2!1spt-BR!2sbr" width="600" height="450" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
        </section>
      </main>

      <footer className='footer'>
        <div className='footer__cerimonial'>
          <img src={LogoCerimonialDourado} />
          <p>Copyright &copy; 2023 Templo Espiritual Maria Santíssima</p>
        </div>

        <div className='footer__grupo'>
          <p>Realização</p>
          <div>
            <img src={LogoTEMS} />
            <img src={SantuarioLogo} />
            <img src={ClaLogo} />
          </div>
        </div>

        <div className='footer__apoiador'>
          <p>Apoiador</p>
          <img src={GraficaAguiaLogo} />
        </div>

        <ul className='footer__list'>
          <a href='https://www.youtube.com/@santuariosarakali' target='_blank'><li><img src={Youtube} /></li></a>
          <a href='https://www.instagram.com/santuariosarakali/' target='_blank'><li><img src={Instagram} /></li></a>
          <a href='https://www.facebook.com/santuariosarakali' target='_blank'><li><img src={Facebook} /></li></a>
          <a href='https://t.me/+-bdPNtP2_iY3NmVh' target='_blank'><li><img src={Telegram} /></li></a>
          <a href='https://twitter.com/temsoficial' target='_blank'><li><img src={Twitter} /></li></a>
        </ul>
      </footer>
    </div>
  )
}